import { z } from 'zod'

export const CreateDocumentFormSchema = z.object({
  role: z.string(),
  replace: z.boolean().default(false),
})

export const createCreateDocumentSchema = (isRoleRequired?: boolean) => {
  return CreateDocumentFormSchema.extend({
    role: isRoleRequired ? z.string().min(1, 'documents.upload.dialog.fields.type.validation') : z.string(),
  })
}

export type CreateDocumentFormSchemaType = z.infer<typeof CreateDocumentFormSchema>
